import { TDataToken, TReorderBulkEntryPayload } from "./type";
import $api from "../../api/$api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

// update canvas layout
export const reorderBulkEntry = (
  data: TDataToken,
  payload: TReorderBulkEntryPayload
) => {
  return $api
    .put("bulk/entry/reorder", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useReorderBulkEntry = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TReorderBulkEntryPayload>
) => {
  return useMutation({
    mutationFn: (payload: TReorderBulkEntryPayload) =>
      reorderBulkEntry(data, payload),
    ...config
  });
};
